module.exports = __webpack_public_path__ + "static/media/individual-tablet.62716fb8.png";